
    module.exports = function cssToMuiLoader(theme) {
      
      return {
        
        'main': {'width': `100%`,'padding': `16px 0px 48px 0px`,'margin': `0px 0px 32px 0px`,},'titleContainer': {'display': `flex`,'justifyContent': `center`,'width': `70%`,'margin': `0 auto`,},
        
      };
    };
  